import gql from 'graphql-tag';

const STOCK_DELIVERY_DETAIL_FRAGMENT = gql`
	fragment stockDeliveryDetail on StockDelivery {
		id
		identifier
		source
		sourceId
		destination
		destinationId
		sourceObj
		destinationObj
		status
		itemCount
		deliveredItemCount
		stockedItemCount
		created
		purchaseOrder {
			id
			created
			identifier
		}
		items {
			id
			quantity
			product {
				id
				name
				imageUrl
				barcodes
				caseSize
				forceQuantityInUnits
				isFreshFood
				expiryDatePolicy
			}
			sourceWarehouseProduct { 
				id
				quantity
				product {
					id
					caseSize
					shipperSize
					palletSize
				forceQuantityInUnits
				isFreshFood
				expiryDatePolicy
			}
			}
			destinationWarehouseProduct {
				id
				quantity
				product {
					id
					caseSize
					shipperSize
					palletSize
				forceQuantityInUnits
				isFreshFood
				expiryDatePolicy
			}
			}
			receivedAt
			deliveredAt
			expiryCaptureRequired
			expiryPolicyContext
			expiryCapturedAt
			expiryBatches {
				id
				quantityOnHand
				expiryDate
				bestBeforeDate
				supplierBatchCode
				status
				receivedAt
				expiryDateSource
				expiryDateUpdatedAt
				expiryDateUpdatedBy {
					id
					firstname
					lastname
				}
			}
		}
	}
`;

const STOCK_DELIVERY_LIST_FRAGMENT = gql`
	fragment stockDelivery on StockDelivery {
		id
		identifier
		source
		sourceId
		destination
		destinationId
		sourceObj
		destinationObj
		status
		itemCount
		deliveredItemCount
		stockedItemCount
		created
		purchaseOrder {
			id
			created
			identifier
		}
	}
`;

export const GET_STOCK_DELIVERY = gql`
	query($id: String) {
		getStockDelivery (id: $id) {
			...stockDeliveryDetail
		}
	}
	${STOCK_DELIVERY_DETAIL_FRAGMENT}
`;

export const GET_STOCK_DELIVERY_LIST = gql`
	query getStockDeliverys(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int,
		$filter: StockDeliveryPageFilter,
	) {
		getStockDeliverys(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...stockDelivery
			}
			count
		}
	}
	${STOCK_DELIVERY_LIST_FRAGMENT}
`;

export const GET_STOCK_DELIVERIES_COUNT = gql`
	query (
		$filter: StockDeliveryCountFilter
	){
		countStockDeliverys(
			filter: $filter,
		)
	}
`;
